// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { TimeBaseEntity } from '../time-base-entity';
import { BillDetail } from './bill-detail';
import { BillStatus } from './bill-status';

/// <code-import> Place custom imports between <code-import> tags
import { Admin } from '..';
export type BillFlags = 'Deleted' | 'TaxEdited' | 'Nominal' | 'MaxAmountTime' | 'MaxAmountDisb';
export const hasFlag = (flags: string, flag: BillFlags): boolean => {
  const parsedFlags = Bill.parseFlags(flags);
  return parsedFlags.some((f) => f === flag);
};
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Bill extends TimeBaseEntity  {

  /// <code> Place custom code between <code> tags
  job: Admin;

  hasFlag(flag: BillFlags): boolean {
    return hasFlag(this.flags, flag);
  }

  setFlag(flag: BillFlags, value: boolean = true): void {
    if (value === false) {
      return this.clearFlag(flag);
    }
    if (this.hasFlag(flag)) {
      return;
    }

    const flags = Bill.parseFlags(this.flags);
    flags.push(flag);
    this.flags = flags.join(', ') || '0';
  }

  clearFlag(flag: BillFlags): void {
    if (!this.hasFlag(flag)) {
      return;
    }

    const flags = Bill.parseFlags(this.flags);
    flags.splice(flags.indexOf(flag), 1);
    this.flags = flags.join(', ') || '0';
  }

  static parseFlags(flags: string): string[] {
    flags = flags || '0'; // Could be numeric zero

    if (flags === '0') {
      return [];
    }
    return flags.split(',').map((flag) => flag.trim());
  }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  billTypeId!: number;
  parentBillId?: number;
  adminId!: number;
  adminTypeId!: number;
  billDisb!: number;
  billDisbWriteOff!: number;
  billFrom?: Date;
  billNet!: number;
  billNotes?: string;
  billTax?: number;
  billTime!: number;
  billTo?: Date;
  billUnits?: number;
  billWriteOff!: number;
  counterpartyId!: number;
  createdAt!: Date;
  createdBy?: string;
  fifoAmount?: number;
  disbFifoAmount?: number;
  flags!: string;
  invoiceDate!: Date;
  statusId!: number;
  taxCodeId?: number;
  ts?: any;
  updatedAt!: Date;
  updatedBy?: string;
  writeOffReason?: string;
  billDetails!: BillDetail[];
  status!: BillStatus;
  parentBill?: Bill;
  childBills!: Bill[];
}

